module.exports = __webpack_public_path__ + "img/pipes@2x.9062aa21.png";